import { css } from 'styled-components';

import { desktop } from '../../techstyle-shared/react-components';

export const skeletonGradient = css`
  @keyframes pulse {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
  animation: pulse 1.2s ease-in-out infinite;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.searchCioSkeletonGradient15} 0%,
    ${({ theme }) => theme.colors.searchCioSkeletonGradient25} 50%,
    ${({ theme }) => theme.colors.searchCioSkeletonGradient15} 100%
  );
  background-size: 200% 100%;
`;

export const constructorTextStandard = css`
  font-size: 14px;
  font-weight: normal;
  font-family: ${({ theme }) => theme.fontStacks.standardGtPressuraFamily};
`;

export const constructorTextBold = css`
  font-size: 14px;
  font-weight: bold;
  font-family: ${({ theme }) => theme.fontStacks.standardGtPressuraFamily};
`;

export const constructorTextHighlight = css`
  position: relative;

  ${desktop`
    &:before {
      content: '';
      position: absolute;
      inset: 0;
      background-color: ${({ theme }) =>
        theme.colors.searchSuggestIsHighlightedBackground};
      border-radius: 6px;
      z-index: -1;
      display: none;
    }

    &:hover::before {
      display: block;
    }
  `}
`;
